export enum Aplicaciones {

    ADMINISTRADOR = "ADMINISTRADOR",
    VALIDADOR = "VALIDADOR",
    TRANSFORMADOR = "TRANSFORMADOR",
    EMISOR = "EMISOR",
    RETAIL = "RETAIL",
    PRINT = "PRINTER",
    THIRDS = "THIRDS"
}



// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/content/seguridad/emisor/recursos/modelo/Aplicaciones.ts